import { cn } from '@/lib/utils';

interface LoadingProps {
  text?: string;
  className?: string;
  fullHeight?: boolean;
}

export function Loading({ text = '加载中...', className, fullHeight = false }: LoadingProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center text-[#64748d]',
        fullHeight ? 'min-h-[240px]' : 'py-12',
        className
      )}
    >
      <div className="flex flex-col items-center gap-3">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-[#e5edf5] border-t-[#533afd]" />
        <span className="text-sm">{text}</span>
      </div>
    </div>
  );
}
